function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M479.492,318.447a233.557,233.557,0,0,1-82.025,121.445A232.008,232.008,0,0,1,24,256,231.861,231.861,0,0,1,421.839,93.807l-2.976,53.576-18.549-5.456a184.564,184.564,0,0,0-32.139-31.792A182.241,182.241,0,0,0,256,72C154.542,72,72,154.542,72,256s82.542,184,184,184a182.236,182.236,0,0,0,112.174-38.135,185.25,185.25,0,0,0,65.083-96.312,24,24,0,1,1,46.235,12.894Zm-9.652-98.84a24,24,0,0,0,10.123-18.276l8-144a24,24,0,1,0-47.924-2.662l-6.32,113.761L326.777,136.976a24,24,0,1,0-13.543,46.048l136,40a23.991,23.991,0,0,0,20.611-3.417Z"
});

var SvgRedo = function SvgRedo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Solid",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redo.e217fdbd.svg";
export { ForwardRef as ReactComponent };